import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { PageContext } from "../contexts/page-context";
import { routeToResourceMap } from "../constants/route-page-map";
import { usePermissions } from "./use-permissions";
import { MaterialTableColumnProps } from "../components/material-table/material-table";

function getByDotKey(obj: any, key: string) {
    return key.split('.').reduce((acc: any, part: string) => acc?.[part], obj);
}

export const usePages = (defaultColumns:MaterialTableColumnProps[] = []) => {
    const context = useContext(PageContext);

    if (!context) {
        throw new Error("usePages must be used within a PageProvider");
    }

    if (context.initializeColumns) {
        context.initializeColumns(defaultColumns);
    }

    const location = useLocation();
    const permissions = usePermissions();
    const mergedRouteToResourceMap = { ...routeToResourceMap, ...context.customRouteToResourceMap };
    const permissionKey = mergedRouteToResourceMap[location.pathname]?.permissionKey;
    const permObj = permissionKey ? getByDotKey(permissions, permissionKey) : null;
    const notAllowedFilters: string[] = permObj?.notAllowedFilters ?? [];

    const schemaFields = notAllowedFilters.length > 0
        ? context.schemaFields.filter((f) => !notAllowedFilters.includes(f.key))
        : context.schemaFields;

    return { ...context, schemaFields };
};
